var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5047 10.7161C19.5047 15.6866 15.4742 19.7161 10.5023 19.7161C5.53048 19.7161 1.5 15.6866 1.5 10.7161C1.5 5.7455 5.53048 1.71606 10.5023 1.71606C13.8345 1.71606 16.7438 3.52596 18.3003 6.21606M17.0351 11.7037L19.2857 9.45372L21.5363 11.7037M13.875 13.1702L10.5 12.0452V7.34106",
    stroke: "#455468",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5ad2cc0b7fce5ef33c9fbe323ef7fc83.svg";
export { ForwardRef as ReactComponent };